import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { VideoTab } from "./components";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function VideoTabs({ productVideoId, setProductVideoId }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Video 1" {...a11yProps(0)} />
          <Tab label="Video 2" {...a11yProps(1)} />
          <Tab label="Video 3" {...a11yProps(2)} />
          <Tab label="Video 4" {...a11yProps(2)} />
          <Tab label="Video 5" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <VideoTab
          productVideoId={productVideoId}
          setProductVideoId={setProductVideoId}
          index={0}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <VideoTab
          productVideoId={productVideoId}
          setProductVideoId={setProductVideoId}
          index={1}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <VideoTab
          productVideoId={productVideoId}
          setProductVideoId={setProductVideoId}
          index={2}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <VideoTab
          productVideoId={productVideoId}
          setProductVideoId={setProductVideoId}
          index={3}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <VideoTab
          productVideoId={productVideoId}
          setProductVideoId={setProductVideoId}
          index={4}
        />
      </TabPanel>
    </Box>
  );
}
